<!--
 * @Author: caoyingming 1046659469@qq.com
 * @Date: 2022-08-25 15:54:26
 * @LastEditors: caoyingming 1046659469@qq.com
 * @LastEditTime: 2022-08-29 16:01:24
 * @FilePath: /genetron-web/genetron-h5/src/views/wx/ybMedicineDetails.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="yb-details">
    <div class="box">
      <h1>FDA批准适应症</h1>
      <div class="show-box"></div>
      <div class="text">
        {{ dataArr.fda }}
      </div>
    </div>
    <div class="box">
      <h1>剂型</h1>
      <div class="show-box"></div>
      <div class="text">
        {{ dataArr.type }}
      </div>
    </div>
    <div class="box">
      <h1>医保支付标准</h1>
      <div class="show-box"></div>
      <div class="text">
        {{ dataArr.insurancePaymentStandard }}
      </div>
    </div>
    <div class="box">
      <h1>限定支付范围</h1>
      <div class="show-box"></div>
      <div class="text">
        {{ dataArr.paymentScope }}
      </div>
    </div>
  </div>
</template>

<script>
import { findByDrugNameList } from "@/api/wxapi.js";

export default {
  data() {
    return {
      dataArr: {},
    };
  },
  mounted() {
    // document.title = this.$route.query.drugName;
    this.getDetails();
  },
  methods: {
    getDetails() {
      findByDrugNameList({
        drugName: this.$route.query.drugName,
        pageNo: 1,
      }).then((res) => {
        console.log(res);
        this.dataArr = res.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.1) 100%
  );
  margin-bottom: 10px;
}
.yb-details {
  padding: 20px 16px;
  font-family: PingFangSC-Regular, PingFang SC;

  .box {
    background: @background_color;
    border-radius: 10px;
    margin-bottom: 20px;
    .text {
      font-size: 14px;
      font-weight: 400;
      color: #5f697d;
      line-height: 28px;
      padding: 0 24px 30px;
      word-break: break-all;
      text-align: justify;
      text-justify: newspaper;
    }
    h1 {
      line-height: 70px;
      font-size: 17px;
      font-weight: 500;
      color: #2f354d;
      padding-left: 24px;
    }
  }
}
</style>